import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
    selector: 'app-settings-card',
    templateUrl: './settings-card.component.html',
})
export class SettingsCardComponent {

    @Input() title?: string
    @Input() description?: string
    @Input() buttonText?: string
    @Input() buttonDisabled = false

    @Output() buttonClick = new EventEmitter<void>()

    onButtonClick() {
        if (this.buttonDisabled) {
            return
        }
        this.buttonClick.emit()
    }
}
